<script>
    import {Router} from "@sveltech/routify";
    import {routes} from "@sveltech/routify/tmp/routes";
    import {documentLoaded} from './modules/ReadyStore';

    export let ready;

	$: if (ready) {
		documentLoaded.update(function() {
			return true;
		})
	};

</script>



<main>
	<Router {routes} />
</main>
